import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-pix-onboarding',
	templateUrl: './onboarding.component.html',
	styleUrls: ['./onboarding.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixOnboardingComponent implements OnInit {

	public step = 1;
	public title = '';
	public text = '';

	returnToWithdrawChangeMenu: boolean;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.setTitleAndText();

		this.returnToWithdrawChangeMenu = !!this.activatedRoute.snapshot.paramMap.get("returnToWithdrawChangeMenu") || false;
	}

	// selectHelp() {
	// 	this.openModalHelp();
	// }

	// openModalHelp() {
	// 	this.dialog.open(PixHelpComponent, {
	// 		width: '400px',
	// 	});
	// }

	setTitleAndText() {
		switch (this.step) {
			case 1:
				this.title = 'Realize transações em segundos';
				this.text = 'Faça transferências e pague contas de forma rápida, sem esperar dias para que o dinheiro fique disponível na sua conta.';
				break;

			case 2:
				this.title = 'Disponível 24 horas por dia, 7 dias da semana';
				this.text = 'O sistema de pagamentos Instantâneos (Pix) funcionará 24 horas por dia, 7 dias da semana, em todos os dias do ano.';
				break;

			case 3:
				this.title = 'Transações com Pix via QR Code';
				this.text = 'Seja para fazer pagamentos ou transferências, o QR Code pode ser lido por qualquer tipo de smartphone.';
				break;

			case 4:
				this.title = 'Notificações em tempo real';
				this.text = 'As notificação de pagamentos acontecem em tempo real para que você tenha mais segurança.';
				break;
		}
	}

	skipApresentation(): void{
		this.setWithExpiry('showOnboardingPixNew', true, new Date());

		if(this.returnToWithdrawChangeMenu){
			this.router.navigate(['pix/pagamento/saque-e-troco', {validateOnboarding: false}]);
			return;
		}

		this.router.navigate(['pix/home']);
	}

	closeApresentation(): void{
		if(this.returnToWithdrawChangeMenu){
			this.router.navigate(['pix/pagamento/saque-e-troco', {validateOnboarding: false}]);
			return;
		}

		this.router.navigate(['pix/home', {validateOnboarding: false}]);
	}

	setWithExpiry(key: string, value: any, date: Date) {
		const item = { value: value, date: date.getTime() };
		localStorage.setItem(key, JSON.stringify(item));
	}

	prev() {
		this.step--;
		this.setTitleAndText();
	}

	next() {
		this.step++;

		if(this.step < 5){
			this.setTitleAndText();
			return;
		}

		if(this.step === 5){
			this.setWithExpiry('showOnboardingPixNew', true, new Date());

			if(this.returnToWithdrawChangeMenu){
				this.router.navigate(['pix/pagamento/saque-e-troco', {validateOnboarding: false}]);
				return;
			}

			this.router.navigate(['pix/home']);
		}

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/onboarding/onboarding.component.ts